import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Category } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { CustomCategoryConnector } from '../../conectors';
import { CustomCategoryActionTypes, LoadCategory, LoadCategoryFail, LoadCategorySuccess } from '../actions/custom-category.action';

@Injectable()
export class CustomCategoryEffects {
  constructor(private actions$: Actions, private categoryConnector: CustomCategoryConnector) {}

  LoadCategory$: Observable<LoadCategorySuccess | LoadCategoryFail> = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomCategoryActionTypes.LOAD_CATEGORY),
      map((action: LoadCategory) => action.payload),
      mergeMap((payload: { code: string }) =>
        this.categoryConnector.get(payload.code).pipe(
          map((category: Category) => {
            return new LoadCategorySuccess(category);
          }),
          catchError((error) => of(new LoadCategoryFail(error)))
        )
      )
    )
  );
}

export const effectsCategory: any[] = [CustomCategoryEffects];
